import React, {useEffect, useState} from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsHeatmap from "highcharts/modules/heatmap"
import {getDetailFromChartClick} from "../utils/getdetails";


HighchartsHeatmap(Highcharts);

export default function HeatMap({mainData, firstRowDivHeight, results, onNestedRowClick, pdb, folder, sortOnClick}) {

    const [options, setOptions] = useState(null);
    const MAX_POINT_FOR_HEATMAP = 100;

    const addInteraction = async (custom) => {
        let functions = [];

        sortOnClick(custom.row[2], custom.row[3], custom.row[1], custom.row[5], custom.row[6], custom.row[4]);

        for (let interaction of custom.interactions) {
            interaction = interaction.trim();
            functions.push(getDetailFromChartClick(folder, pdb, interaction, custom.row).then((res) => {
                res.forEach(row => {
                    onNestedRowClick(row, interaction, false);
                })
            }));
        }

        await Promise.all(functions).then(function (results) {
            document.getElementById("molstar").scrollIntoView({behavior: 'smooth'});
        })
    };

    const getAxis = (data, index) => {
        let axis = new Set();

        for (let row of data) {
            axis.add(parseInt(row[index]));
        }

        return Array.from(axis);
    };

    //,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Type of Interactions
    const getData = (data, xAxis, yAxis) => {
        let _data = [];
        data.forEach(row => {
            const interactions = row[7].split(';').filter(i => i !== "")
            const interactionSet = new Set(interactions)
            const tooltip = `${row[1]}${row[2]}_${row[3]} - ${row[4]}${row[5]}_${row[6]} <br/>${[...interactionSet].join('<br/>')}`;

            const point = {
                x: xAxis.indexOf(parseInt(row[2])),
                y: yAxis.indexOf(parseInt(row[5])),
                value: interactions.length,
                custom: {tooltipValue: tooltip, row: row, interactions: interactionSet}
            };

            _data.push(point);
        });
        return _data;
    }

    useEffect(() => {
        const xAxisArr = getAxis(mainData, 2);
        const yAxisArr = getAxis(mainData, 5);
        const xAxis = xAxisArr.sort((a, b) => a - b);
        const yAxis = yAxisArr.sort((a, b) => b - a);
        const data = getData(mainData, xAxis, yAxis);

        const options = {
            chart: {
                renderTo: "container",
                type: "heatmap",
                plotBorderWidth: 1,
                height: firstRowDivHeight
            },
            title: {
                text: 'Atomic Interactions <br/> Heatmap'
            },
            subtitle: {
                text:
                    ''
            },
            colorAxis: {
                min: 0,
                minColor: '#FFFFFF',
                maxColor: Highcharts.getOptions().colors[0]
            },
            xAxis: {
                categories: xAxis,
                title: {
                    text: results.mol1 ? `${results.mol1}` : `CHAIN ${mainData[0][3]}`,
                    style: {
                        fontWeight: 'bold',
                    }
                },
                gridLineWidth: 1
            },
            yAxis: {
                categories: yAxis,
                title: {
                    text: results.mol2 ? `${results.mol2}` : `CHAIN ${mainData[0][6]}`,
                    style: {
                        fontWeight: 'bold',
                    }
                },
                reversed: true,
                gridLineWidth: 1
            },
            legend: {
                align: 'left',
                layout: 'horizontal',
                margin: 0,
                verticalAlign: 'bottom',
                y: 0,
                x: 50,
                symbolHeight: 280,
                enabled: data.length >= MAX_POINT_FOR_HEATMAP,
            },
            series: [{
                name: 'interactions',
                borderWidth: 1,
                data: data,
                tooltip: {
                    pointFormatter: function () {
                        return `<b>${this.custom.tooltipValue}</b>`;
                    },
                },
                point: {
                    events: {
                        click: function () {
                            addInteraction(this.custom);
                            console.log('Custom:', this.custom);
                        }
                    }
                },
                dataLabels: {
                    enabled: data.length <= MAX_POINT_FOR_HEATMAP,
                    color: '#000000',
                    format: '{point.value}',
                    style: {
                        fontSize: '14px', // Regola la dimensione del testo
                    }
                }
            }]
        };

        setOptions(options);

    }, [mainData, firstRowDivHeight]);

    return (
        <div style={{paddingLeft: '40px', paddingRight: '40px'}}>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </div>
    )
}